import {observer} from 'mobx-react-lite';
import {useEffect, useState} from 'react';
import {useStore} from '@/store/root-store';
import {TermsDropdownController} from '../DropdownController/TermsDropdownController';
import styled from 'styled-components';
import {toJS} from 'mobx';
import {TermsDataController} from '../DropdownController/TermsDataController';
import {SingleTerm} from './SingleTerm';
import {FocusTermModel} from '@/store/content-optimizer/currentPage';
import {Tooltip} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCopy} from '@fortawesome/pro-regular-svg-icons';

export const TermsDropdowns = observer(() => {
  // const [defaultActiveCluster, setDefaultActiveCluster] = useState<string | string[]>(['1']);
  const [includedBranded, setIncludeBranded] = useState(true);
  const [query, setQuery] = useState([]);
  const [termsToShow, setTermsToShow] = useState(['include-more', 'included', 'include-less']);
  const [isCopied, setIsCopied] = useState(false);

  const {
    contentOptimizer: {
      currentPage,
    }} = useStore('');


  const [standardTerms, setStandardTerms] = useState<FocusTermModel[]>([]);

  const setTerms = (queryParam?: string[]) => {
    if (queryParam?.length) {
      setQuery(queryParam);
    } else {
      setQuery([]);
    }

    const prepTermsArr = toJS(currentPage?.analytics?.focusTerms);
    let filteredTerms = [];

    if (queryParam?.length) {
      for (let i = 0; i < queryParam.length; i++) {
        filteredTerms = [...filteredTerms, ...prepTermsArr.filter(term => term.name.includes(queryParam[i]))];
      }
    } else {
      filteredTerms = prepTermsArr;
    }

    if (currentPage.focusTermsSorter.key) {
      if (currentPage.focusTermsSorter.key === 'leastCount') {
        filteredTerms = filteredTerms?.sort((a, b) => {
          if (a.usedCount < b.usedCount) return -1;
        });
      } else {
        filteredTerms = filteredTerms?.sort((a, b) => {
          if (b[currentPage.focusTermsSorter.key] < a[currentPage.focusTermsSorter.key]) return -1;
        });
      }
    }


    filteredTerms = filteredTerms?.filter(term => termsToShow.includes(term.status));

    setStandardTerms(filteredTerms);
  };

  const filterTermsHandler = (termsToShowParam: string[]) => {
    setTermsToShow(termsToShowParam);
    const prepTermsArr = toJS(currentPage?.analytics?.focusTerms);
    let filteredTerms = [];

    if (query?.length) {
      for (let i = 0; i < query.length; i++) {
        filteredTerms = [...filteredTerms, ...prepTermsArr.filter(term => term.name.includes(query[i]))];
      }
    } else {
      filteredTerms = prepTermsArr;
    }

    if (currentPage.focusTermsSorter.key) {
      filteredTerms = filteredTerms?.sort((a, b) => {
        if (b[currentPage.focusTermsSorter.key] < a[currentPage.focusTermsSorter.key]) return -1;
      });
    }

    filteredTerms = filteredTerms?.filter(term => termsToShowParam.includes(term.status));

    setStandardTerms(filteredTerms);
  };

  useEffect(() => {
    setTerms();
  }, [...(currentPage?.analytics?.focusTerms ?? [])]);


  return <>
    <TermsDataController
      store={currentPage}
      onFilter={setTerms}/>
    <TermsDropdownController
      store={currentPage}
      onChangeIncludeBranded={setIncludeBranded}
      onSortTerms={setTerms}
      onTermsFilter={filterTermsHandler}
      includeBranded={includedBranded}/>
    <TopicalTermsContainer>
      <TermsContainer focusMode={currentPage?.focusTermsExpanded}>
        {standardTerms.filter(term => {
          if (!includedBranded) {
            return !term.isBranded;
          } else {
            return term;
          }
        }).map((term, idx) => {
          return <SingleTerm key={idx} i={idx} focusTerm={term} store={currentPage}/>;
        })}
      </TermsContainer>
      <Tooltip
        title={isCopied ? '' : 'Copy all topical terms'}
        trigger='hover'
        placement='bottom'
        onVisibleChange={visible => {
          if (!visible) {
            setTimeout(() => setIsCopied(false), 300);
          }
        }}>
        <CopyButton
          onClick={()=>{
            if (standardTerms?.length) {
              navigator.clipboard.writeText(standardTerms.filter(term => {
                if (!includedBranded) {
                  return !term.isBranded;
                } else {
                  return term;
                }
              })?.map(i => i?.name).join(', '));
            }
            setIsCopied(true);
          }}
        ><FontAwesomeIcon icon={faCopy} /> {isCopied ? 'Copied' : 'Copy All'}</CopyButton>
      </Tooltip>
    </TopicalTermsContainer>
  </>;
});

const TopicalTermsContainer = styled.div`
background-color: #2D2F34;
  
`;

const TermsContainer = styled.div<{focusMode?: boolean}>`
  padding-right: 15px;
  padding-bottom: 16px;
  border-radius: 0 0 8px 8px;
  display: flex;
  flex-wrap: wrap;
  max-height: ${p => !p.focusMode ? '476px' : 'calc(100vh - 440px)'};
  overflow-y: auto;
  
  // For Internet Explorer
  scrollbar-face-color: rgba(138,138,138,0.32);
  scrollbar-track-color: rgba(138,138,138,0.12);

  // For Google Chrome
  &::-webkit-scrollbar {
    height: 5px;
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #E8E8E8;
  }

  &::-webkit-scrollbar-track {
    background: rgba(138,138,138,0.12);
  }
`;

const CopyButton = styled.button`
  background-color: transparent;
  border: 0px;
  cursor: pointer;
  margin: 6px;
  color: rgb(52, 174, 243);
`;

